module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Forward-20d9c4c8a2adf97967f2a8b62f60826f.svg";